module.exports = __webpack_public_path__ + "img/Cica404.b50667bc.png";